import * as React from 'react'
import { observer } from 'mobx-react-lite'
import { appStore } from '../../../index'
import { Pages } from '../../../Stores/AppStore'
import { Button, ButtonType, Container } from '../../UI'
import classes from './Assignment.module.css'
import { AssignmentStatus } from '../../../ApiModels'
import { LNG } from '../../../Services/LanguageService';

export const Assignment = observer(() => {
  const _onDoneClick = () => {
    appStore.setPage(Pages.Home)
  }
  const _onAssignmentsClick = () => {
    appStore.setPage(Pages.PreviousAssignment)
  }

  const _actions = (
    <>
      <Button label={LNG.Text('scannerApp.5')} onClick={_onAssignmentsClick}/>
      <Button label={LNG.Text('scannerApp.22')} type={ButtonType.Primary} onClick={_onDoneClick}/>
    </>
  )
  const successfulPositions = appStore.appState.assignment?.successfulPositions.join(', ')
  const failedPositions = appStore.appState.assignment?.failedPositions.join(', ')
  return (
    <Container actions={_actions}>
      <div className={classes.root}>
        <div className={classes.title}>{LNG.Text('scannerApp.28')}</div>

        {(appStore.appState.assignment?.assignmentFinished === false || appStore.appState.assignment?.status === AssignmentStatus.AssignmentInProgress) &&
          <div className={classes.status}><span className={`${classes.progress} ${classes.success}`}>{LNG.Text('scannerApp.29')}</span></div>
        }

        {appStore.appState.assignment?.status === AssignmentStatus.Expired &&
          <div className={classes.status}><span className={`${classes.progress} ${classes.error}`}>{LNG.Text('scannerApp.30')}</span></div>
        }

        {appStore.appState.assignment?.status === AssignmentStatus.Failed &&
          <div className={classes.status}><span className={`${classes.progress} ${classes.error}`}>{appStore.appState.assignment?.assignmentError}</span></div>
        }

        {(appStore.appState.assignment?.assignmentFinished || appStore.appState.assignment?.status === AssignmentStatus.Success) &&
          <>
            <div className={classes.group}>{LNG.Text('scannerApp.31')}</div>
            <div className={classes.text}>{LNG.Text('scannerApp.32')}: <b>{successfulPositions}</b></div>

            <div className={classes.group}>{LNG.Text('scannerApp.33')}</div>
            <div className={classes.text} hidden={!!failedPositions}><b>{LNG.Text('scannerApp.34')}</b></div>
            <div className={classes.text} hidden={!failedPositions}>{LNG.Text('scannerApp.32')}: <b>{failedPositions}</b></div>
            <div className={classes.text} hidden={!appStore.appState.assignment?.error}>{LNG.Text('scannerApp.35')}: <b>{appStore.appState.assignment?.error}</b></div>
          </>
        }

        <div className={classes.group}>{LNG.Text('scannerApp.36')}</div>
        <div className={classes.text}>{appStore.appState.assignment?.machineId}</div>

        <div className={classes.group}>{LNG.Text('scannerApp.15')}</div>
        <div className={classes.text}>{appStore.appState.assignment?.rid}</div>

        <div className={classes.text}>{LNG.Text('scannerApp.16')}: <b>{appStore.appState.assignment?.orderNumber}</b></div>

      </div>

    </Container>
  )
})
